export default __webpack_public_path__ + "static/media/paw-prints.e2834798.svg";